(function () {

  function init() {
    if (!window.tvModelsUrl) return;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        fetch(window.tvModelsUrl)
          .then(r => r.json())
          .then(data => {
            document.querySelectorAll('.tv-konfigurator').forEach(el => {
              const variantId = Number(el.dataset.variantId);
              const cartItem = cart.items.find(item => item.variant_id === variantId);

              // Konfigurator ausblenden, wenn VESA bereits gesetzt wurde
              const alreadyConfigured = cartItem && cartItem.properties && cartItem.properties['TV VESA'];
              if (alreadyConfigured) {
                el.style.display = 'none';
                return;
              }

              buildForm(el, data);
            });
          })
          .catch(e => console.error('TV JSON Fehler:', e));
      })
      .catch(e => console.error('Cart Fehler:', e));
  }

  window.initTVKonfigurator = init;

  function buildForm(el, data) {
    const line = el.dataset.line;
    const range = el.dataset.groessenRange || '';
    const parts = range.replace(/[^0-9\-]/g, '').split('-').map(Number);
    const min = parts[0] || 0;
    const max = parts[1] || 999;

    // 3‑Dropdown‑Formular
    el.innerHTML = `
  <div class="tv-form" style="margin:10px 0;">
    <div style="display:flex; align-items:center; margin-bottom:6px; gap:8px;">
      <label style="min-width:80px; margin:0;">Hersteller</label>
      <select class="tv-hersteller" style="flex:1;">
        <option value="">Bitte wählen...</option>
        <option value="__nicht_gelistet__">Mein TV ist nicht gelistet</option>
        ${Object.keys(data).map(h => `<option value="${h}">${h}</option>`).join('')}
      </select>
    </div>

    <div style="display:flex; align-items:center; margin-bottom:6px; gap:8px;">
      <label style="min-width:80px; margin:0;">Größe</label>
      <select class="tv-groesse" style="flex:1;" disabled>
        <option value="">Bitte wählen...</option>
        <option value="__nicht_gelistet__">Mein TV ist nicht gelistet</option>
      </select>
    </div>

    <div style="display:flex; align-items:center; margin-bottom:6px; gap:8px;">
      <label style="min-width:80px; margin:0;">Serie</label>
      <select class="tv-serie" style="flex:1;" disabled>
        <option value="">Bitte wählen...</option>
        <option value="__nicht_gelistet__">Mein TV ist nicht gelistet</option>
      </select>
    </div>

    <div class="tv-manuell" style="display:none; margin-top:6px;">
      <label>TV-Modell manuell eingeben</label>
      <input type="text" class="tv-manuell-input" placeholder="z.B. Samsung QE55Q80C" style="width:100%;">
    </div>
  </div>
`;

    const hSel = el.querySelector('.tv-hersteller');
    const gSel = el.querySelector('.tv-groesse');
    const sSel = el.querySelector('.tv-serie');
    const manuell = el.querySelector('.tv-manuell');
    const manuellInput = el.querySelector('.tv-manuell-input');

    // Hersteller
    hSel.addEventListener('change', function (e) {
      e.stopImmediatePropagation();

      gSel.innerHTML = '<option value="">Bitte wählen...</option><option value="__nicht_gelistet__">Mein TV ist nicht gelistet</option>';
      sSel.innerHTML = '<option value="">Bitte wählen...</option><option value="__nicht_gelistet__">Mein TV ist nicht gelistet</option>';
      gSel.disabled = true; 
      sSel.disabled = true;
      manuell.style.display = 'none';

      if (this.value === '__nicht_gelistet__') { 
        manuell.style.display = 'block'; 
        return; 
      }

      if (!this.value || !data[this.value]) return;

      const sizes = Object.keys(data[this.value]).map(Number).filter(s => s >= min && s <= max).sort((a,b) => a-b);
      sizes.forEach(s => {
        const o = document.createElement('option');
        o.value = s; 
        o.textContent = s + '"';
        gSel.appendChild(o);
      });
      gSel.disabled = false;
    });

    // Größe
    gSel.addEventListener('change', function (e) {
      e.stopImmediatePropagation();

      sSel.innerHTML = '<option value="">Bitte wählen...</option><option value="__nicht_gelistet__">Mein TV ist nicht gelistet</option>';
      sSel.disabled = true;
      manuell.style.display = 'none';

      if (this.value === '__nicht_gelistet__') { 
        manuell.style.display = 'block'; 
        return; 
      }

      const h = hSel.value;
      if (!this.value || !data[h] || !data[h][this.value]) return;

      Object.keys(data[h][this.value]).forEach(s => {
        const o = document.createElement('option');
        o.value = s; 
        o.textContent = s;
        sSel.appendChild(o);
      });
      sSel.disabled = false;
    });

    // Serie → VESA speichern
    sSel.addEventListener('change', function (e) {
      e.stopImmediatePropagation();

      manuell.style.display = 'none';

      if (this.value === '__nicht_gelistet__') { 
        manuell.style.display = 'block'; 
        return; 
      }

      const h = hSel.value;
      const g = gSel.value;
      const serie = this.value;

      if (!data[h] || !data[h][g] || !data[h][g][serie]) return;

      const vesa = data[h][g][serie].vesa;

      saveToCart(line, h, g, serie, vesa);
    });

    // Manuell
    manuellInput.addEventListener('change', function (e) {
      e.stopImmediatePropagation();
      if (this.value.trim()) saveToCart(line, 'Manuell', '', '', this.value.trim());
    });
  }

  // Speichern
  function saveToCart(line, hersteller, groesse, serie, vesa) {
    const quantityInput = document.getElementById(`Quantity-${line}`);
    if (quantityInput) quantityInput.disabled = true;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const cartLine = cart.items[Number(line) - 1];
        const existingProperties = cartLine ? cartLine.properties : {};

       const mergedProperties = Object.assign({}, existingProperties, {
  'TV Hersteller': hersteller,
  'TV Größe': groesse,
  'TV Serie': serie,
  'TV VESA': vesa,
  'TV Modell': `Serie: ${serie}`   // <- WICHTIG: Theme erwartet dieses Feld!
});


        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(line), properties: mergedProperties })
        });
      })
      .then(() => {
        fetch('/cart?sections=main-cart-items')
          .then(r => r.json())
          .then(data => {
            const html = data['main-cart-items'];
            if (html) {
              const parsed = new DOMParser().parseFromString(html, 'text/html');
              const newCart = parsed.querySelector('cart-items');
              document.querySelector('cart-items').innerHTML = newCart.innerHTML;
              setTimeout(() => {
                window.initTVKonfigurator();
                document.querySelectorAll('.cart-item__error-text').forEach(el => el.textContent = '');
              }, 100);
            }
          });
      })
      .catch(e => console.error('Cart update Fehler:', e));
  }

  // KEIN Checkout-Blocker mehr an dieser Stelle

  document.addEventListener('cart:refresh', () => setTimeout(init, 300));
  document.addEventListener('cart-drawer:open', () => setTimeout(init, 300));
  document.addEventListener('cart:updated', () => setTimeout(init, 300));

  document.addEventListener('click', (e) => {
    const deleteBtn = e.target.closest('[data-index]');
    if (deleteBtn && deleteBtn.closest('cart-items')) setTimeout(init, 500);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
